import React from 'react';

type AuditColumnStyle = React.CSSProperties & {
  width: number;
  minWidth: number;
  maxWidth: number;
};

const makeColumnStyle = (width: number): AuditColumnStyle => ({
  width,
  minWidth: width,
  maxWidth: width,
});

export const AUDIT_TABLE_COLUMN_STYLES = {
  date: makeColumnStyle(200),
  metric: makeColumnStyle(94),
  inventoryMovementMetric: makeColumnStyle(69),
} as const;

const INVENTORY_MOVEMENT_COLUMN_LABELS = new Set([
  'Opening',
  'Activated to Backstock',
  'Counter to Backstock',
  'Backstock to Counter',
  'Returned to Lottery',
  'Sold Out',
  'Closing',
  'Opening Tickets',
  'Activated Tickets',
  'From Backstock',
  'To Backstock',
  'Closing Tickets',
  'Expected Sales',
]);

const COLUMN_STYLE_BY_LABEL: Record<string, AuditColumnStyle> = {
  Opening: AUDIT_TABLE_COLUMN_STYLES.metric,
  Closing: AUDIT_TABLE_COLUMN_STYLES.metric,
  'Active in Backstock': AUDIT_TABLE_COLUMN_STYLES.metric,
  'Activated to Backstock': AUDIT_TABLE_COLUMN_STYLES.metric,
  'Counter to Backstock': AUDIT_TABLE_COLUMN_STYLES.metric,
  'Backstock to Counter': AUDIT_TABLE_COLUMN_STYLES.metric,
  'Returned to Lottery': AUDIT_TABLE_COLUMN_STYLES.metric,
  'Opening Tickets': AUDIT_TABLE_COLUMN_STYLES.metric,
  'Activated Tickets': AUDIT_TABLE_COLUMN_STYLES.metric,
  'Closing Tickets': AUDIT_TABLE_COLUMN_STYLES.metric,
  'Expected Sales': AUDIT_TABLE_COLUMN_STYLES.metric,
  'POS Sales': AUDIT_TABLE_COLUMN_STYLES.metric,
  'Scratcher Qty': AUDIT_TABLE_COLUMN_STYLES.metric,
  'Scratcher Sales': AUDIT_TABLE_COLUMN_STYLES.metric,
  'Lottery Reported Sales': AUDIT_TABLE_COLUMN_STYLES.metric,
  'POS Lotto Sales': AUDIT_TABLE_COLUMN_STYLES.metric,
  'Lottery Reported Payouts': AUDIT_TABLE_COLUMN_STYLES.metric,
  'Lottery Reported Free Tickets': AUDIT_TABLE_COLUMN_STYLES.metric,
  'POS Payouts': AUDIT_TABLE_COLUMN_STYLES.metric,
  Variance: AUDIT_TABLE_COLUMN_STYLES.metric,
};

export const getAuditColumnStyle = (
  columnLabel: string,
  useInventoryMovementWidth = false
): AuditColumnStyle => {
  if (useInventoryMovementWidth && INVENTORY_MOVEMENT_COLUMN_LABELS.has(columnLabel)) {
    return AUDIT_TABLE_COLUMN_STYLES.inventoryMovementMetric;
  }

  return COLUMN_STYLE_BY_LABEL[columnLabel] ?? AUDIT_TABLE_COLUMN_STYLES.metric;
};

export const getAuditTableColStyles = (
  columnConfig: readonly string[],
  showNetVariance: boolean,
  useInventoryMovementWidth = false
): AuditColumnStyle[] => [
  AUDIT_TABLE_COLUMN_STYLES.date,
  ...columnConfig.map((columnLabel) => getAuditColumnStyle(columnLabel, useInventoryMovementWidth)),
  ...(showNetVariance ? [AUDIT_TABLE_COLUMN_STYLES.metric] : []),
];
